import { AuthXInterceptor } from '../Config/AuthXInterceptor'

export interface TimelineUser {
  resourceId: string
  firstName: string
  lastName: string
  email: string
  phone: string
  emailVerifiedAt: string | null
  phoneVerifiedAt: string | null
  disabledAt: string | null
}

export interface TimelineItem {
  resourceId: string
  action: string
  actor_type: string
  about_type: string
  about_id: number
  note: string
  metadata: Record<string, any>
  action_by_user: TimelineUser
  createdAt: string
}

export interface TimelineResponse {
  type: string
  code: number
  message: string
  data: TimelineItem[]
  meta: string
}

export interface TimelineParams {
  page?: number
  limit?: number
  sortOrder?: 'ASC' | 'DESC'
}

export const timelineBXService = {
  index: async (params: TimelineParams = {}) => {
    const { page = 1, limit = 10, sortOrder = 'DESC' } = params
    
    return AuthXInterceptor.get('timelines', {
      params, 
    })
  }
}

export default timelineBXService
